import { buildBreadcrumbNavigationConfig } from "../shared/helpers/buildBreadcrumbNavigationConfig";
import { CollectiblesContainer } from "./pages/collectibles.container";

const collectiblesContentPath = "/shared-collectibles";

const collectiblesContentPageNav = buildBreadcrumbNavigationConfig(
  "Shared Collectibles",
  collectiblesContentPath
);

export const routes = [
  {
    path: collectiblesContentPath,
    Component: CollectiblesContainer,
    navigation: [collectiblesContentPageNav],
    exact: true,
    isPrivate: true,
  },
];
